import { render, staticRenderFns } from "./roleform.vue?vue&type=template&id=f6d7be82&scoped=true&"
import script from "./roleform.vue?vue&type=script&lang=js&"
export * from "./roleform.vue?vue&type=script&lang=js&"
import style0 from "./roleform.vue?vue&type=style&index=0&id=f6d7be82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7be82",
  null
  
)

export default component.exports